import GoalSettingsDialog from './GoalSettingsDialog.component';

export { hasVisibleGoalSettings } from './GoalSettingsDialog.component';
export type { GoalSettingsValues } from './interfaces';

export default GoalSettingsDialog;
